import dynamic from 'next/dynamic';
import PropTypes from 'prop-types';

import Icon from 'shopper/components/Icon';

import useDialog from 'hooks/useDialog';
import useMediaQuery from 'hooks/useMediaQuery';

import { sendEvent } from 'lib/gtag';
import placeholder from 'lib/placeholder';

import Button from '../../../Shopper/Button';

const LoginDialog = dynamic(() => import('components/LoginDialog'), {
  ssr: false,
});

const SignUpButton = ({ gaEventCategory, ...rest }) => {
  const { showDialog } = useDialog();
  const { isLg } = useMediaQuery();

  const onSignUpButtonClickHandler = () => {
    sendEvent({
      action: isLg ? 'topbar_login' : 'topbar_login_webmobile',
      category: gaEventCategory,
    });

    showDialog(LoginDialog);
  };

  return (
    <Button
      aria-label="Abrir modal de cadastro"
      className="relative"
      data-test-selector="open-signup-modal"
      icon={<Icon name="user" />}
      onClick={onSignUpButtonClickHandler}
      {...rest}
    >
      {placeholder('actions.signin')}
    </Button>
  );
};

SignUpButton.propTypes = {
  gaEventCategory: PropTypes.string.isRequired,
};

export default SignUpButton;
